import React from 'react';
// import CyberThreats2023 from 'views/CyberThreats2023';
import CyberThreats2023 from 'views/LibraryManagement2023/CyberThreats2023';

const StudentsTestimonialpage = () => {
  return <CyberThreats2023 />;
};

export default StudentsTestimonialpage;